<template>
  <validation-observer ref="followUpFormRef" novalidate tag="form">
    <div class="mx-4">
      <div class="row mb-3 pt-3">
        <div class="col-12">
          <icon-view
            :icon="icon"
            :icon-background="iconBackground"
            :icon-color="iconColor"
            icon-size="14px"
            :title="sectionTitle"
            variant="custom-icon-view"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddAdditionalSection"
              v-model="model.selectedOption"
              class="custom-drop-down"
              custom-error-msg="Es requerido seleccionar una Categoría."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :label="ddTitle"
              :options="options"
            />
          </validation-provider>
        </div>
        <div class="col-2 order-2 order-md-0 order-sm-1 mt-3 mt-md-0 mt-sm-3" />
      </div>
      <div class="row">
        <div class="col-12 mt-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              id="txtAdditionalSectionComment"
              v-model="model.comment"
              custom-error-msg="Es requerido documentar un comentario."
              :error="errors[0]"
              label="Comentario:"
              :maxlength="2000"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-5 mt-md-0 mt-sm-3 pb-3 pt-3">
        <div class="col-5 d-flex justify-content-start align-items-center">
          <check-box v-model="openAdditionalSection" class="w-auto" />
          <span class="mr-2 color-gray-7 font-weight-bold font-16">
            {{ chkTitle }}
          </span>
        </div>
        <div
          v-if="!openAdditionalSection"
          class="col-7 d-flex align-items-center justify-content-md-end justify-content-sm-none"
        >
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger px-3 mr-2"
            @click="onCancel()"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-save"
            variant="success px-3"
            @click="onConfirm()"
          >
            Guardar
          </action-button>
        </div>
      </div>
      <div v-if="openAdditionalSection">
        <hr />
        <div class="row mb-3 pt-4">
          <div class="col-12">
            <icon-view
              :icon="icon"
              :icon-background="iconBackground"
              :icon-color="iconColor"
              icon-size="14px"
              :title="chkTitle"
              variant="custom-icon-view"
            />
          </div>
        </div>
        <additional-child-section
          v-if="assistanceSummariesRelated"
          :assistance-summaries="assistanceSummariesRelated"
          :message-error="messageError"
          :show-status-indicator="showStatusIndicator"
          @on-set-list="onSetList"
        />

        <div class="row">
          <div
            class="col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none my-4"
          >
            <action-button
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger px-3 mr-2"
              @click="onCancel()"
            >
              Cancelar
            </action-button>
            <action-button
              i="fas fa-save"
              variant="success px-3"
              @click="onConfirm()"
            >
              Guardar
            </action-button>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import AdditionalChildSection from './AdditionalChildSection';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'AdditionalSection',
  components: {
    ValidationObserver,
    ValidationProvider,
    IconView,
    CustomDropDown,
    CustomTextArea,
    ActionButton,
    AdditionalChildSection,
  },
  mixins: [alertMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    assistanceSummariesRelated: {
      type: Array,
      default: () => [],
    },
    assistanceSummaryId: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    ddTitle: {
      type: String,
      required: true,
    },
    chkTitle: {
      type: String,
      required: true,
    },
    sectionTitle: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconBackground: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: true,
    },
    showStatusIndicator: {
      type: Boolean,
      default: () => false,
    },
    messageError: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    model: {
      selectedOption: null,
      comment: null,
    },
    openAdditionalSection: false,
    selectedItems: [],
  }),
  watch: {
    openAdditionalSection: function(value) {
      if (value) {
        this.selectedItems = [];
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit('on-cancel');
    },
    async onConfirm() {
      const isValid = await this.$refs.followUpFormRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Todos los campos deben ser completados para completar la acción',
          'error'
        );
        return;
      }

      let item = {
        comment: this.model.comment,
        optionId: this.model.selectedOption.id,
        assistanceSummaryIds: [...this.selectedItems, this.assistanceSummaryId],
      };

      this.$emit('on-confirm', this.index, item);
    },
    onSetList(assistanceSummaryIds) {
      this.selectedItems = assistanceSummaryIds;
    },
  },
};
</script>
